import { serviceroot } from '../config';
class glassWall {
    public material: number;
    public doorWidth: number;
    public doorHeight: number;
    public upGlassEnabled: boolean;
    public upGlassHeight: number;
    public leftSideGlassEnabled: boolean;
    public leftSideGlassHeight: number;
    public leftSideGlassWidth: number;
    public rightSideGlassEnabled: boolean;
    public rightSideGlassHeight: number;
    public rightSideGlassWidth: number;
    public glassWallType: number;
}

let url = serviceroot + "/api/GlassWallPrice/GetPrice";

class glassWallPriceService {
    public getPriceAsync(glassWall: glassWall) {
        let request = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(glassWall)
        };
        return fetch(url, request).then(response => response.text()).then(text => parseFloat(text));
    };
}

export { glassWallPriceService,glassWall };
